<script setup lang="ts">
import { useRoute } from 'vue-router';
import ProgressReport from '@/views/Reports/ProgressReport';
</script>

<template><ProgressReport class="p-0 w-full" :student-id="useRoute().params.id" /></template>
